import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal, message, Input, Divider, Popover, Button } from 'antd';
import {
  CaretUpOutlined,
  CaretDownOutlined,
  UpOutlined,
  DownOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import {
  _hide_login_modal,
  _show_login_modal,
  _set_uid_token,
  _get_user_info,
  _get_point,
  _anly_seng_custom,
  _is_new_process,
  _show_account_abnormal_modal,
} from '../../store/Action';
import QQLogin from './QQLogin';
import WeixinLogin from './WeixinLogin';
import HTTP from '../../script/service';
import Util from '../../script/util';
import NewbiePack from '../newbiePack/newbiePack';
import WeChatLogin from './WeChatLogin';
import qs from 'qs';
import ConfrimIframeModal from '../iframModal/ConfrimIframeModal';
import './newLogin.scss';
import LoginQuestion from './component/LoginQuestion';
import BindPhoneSY from '../bindPhone/BindPhoneSY';
import NationCode from '../nationCode/nationCode';
import jxCaptchaVerifiedHOC from '../jxCaptchaVerifiedHOC';

message.config({
  top: 100,
  duration: 2,
  maxCount: 1,
});
let Password = Input.Password;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone_visible: false,
      weixin_visible: false,
      qq_visible: false,
      qq_open: false,
      line_visible: false,
      phone: '',
      code: '',
      time: 0,
      loading: false,
      nationCode: '852',
      nationVisible: false,
      isAgree: true,
      loginType: 0, //0手机号+验证码 1手机号+密码
      password: '',
      loginErrorTxt: null, // 错误文案提示
      isShowErrorIcon: false, // 是否展示显示更多错误的 icon
    };
  }

  showFacebookLogin = () => {
    const { rootConfig } = this.props.base;
    Util.setCookie('loginFrom', '4');
    Util.setCookie('dfSearch', window.location.search);
    const param = {
      display: '',
      callbackURI:
        window.location.protocol +
        '//' +
        window.location.host +
        '/loginCallback.html?v=' +
        this.props.base.rootConfig.version,
      companyId: rootConfig.companyIdSY,
      appKey: rootConfig.appKeySY,
      appSecret: '',
      appType: 1,
      appChannel: '',
    };
    const url = `${rootConfig.loginUrl}/fb/login.do?`;
    window.location.href = url + qs.stringify(param);
    _hide_login_modal();
  };

  showLineLogin = () => {
    const { rootConfig } = this.props.base;
    Util.setCookie('loginFrom', '5');
    Util.setCookie('dfSearch', window.location.search);
    const param = {
      display: '',
      callbackURI:
        window.location.protocol +
        '//' +
        window.location.host +
        '/loginCallback.html?v=' +
        this.props.base.rootConfig.version,
      companyId: rootConfig.companyIdSY,
      appKey: rootConfig.appKeySY,
      appSecret: '',
      appType: 1,
      appChannel: '',
    };
    const url = `${rootConfig.loginUrl}/line/login.do?`;
    window.location.href = url + qs.stringify(param);
    _hide_login_modal();
  };

  showQQLogin = () => {
    const { rootConfig } = this.props.base;
    _hide_login_modal();
    const browser = Util.getBrowserInfo();
    if (browser.name == 'chrome' && parseInt(browser.version) >= 80) {
      this.setState({
        qq_visible: false,
        qq_open: true,
        loginErrorTxt: null,
        isShowErrorIcon: false,
      });
      const param = {
        display: '',
        callbackURI:
          window.location.protocol +
          '//' +
          window.location.host +
          '/loginCallback.html?v=' +
          rootConfig.version,
        companyId: rootConfig.companyIdSY,
        appKey: rootConfig.appKeySY,
        appSecret: '',
        appType: 1,
        appChannel: '',
        oauthType: 2,
      };
      //方案1
      // Util.setCookie('loginFrom', '2');
      // Util.setCookie('dfSearch', window.location.search);
      // window.location.href = "https://web.jiezhansifang.com/v2/thirdparty/qq/login.do?" + qs.stringify(param);
      //方案2
      const l = (window.screen.availWidth - 780) / 2;
      const t = (window.screen.availHeight - 549) / 2;
      const url = `${rootConfig.loginUrl}/v2/thirdparty/qq/login.do?`;
      window.open(
        url + qs.stringify(param),
        '第三方登录',
        'height=549,innerHeight=549,width=780,innerWidth=780,top=' +
          t +
          ',left=' +
          l +
          ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'
      );
    } else {
      this.setState({
        qq_visible: true,
        qq_open: false,
        loginErrorTxt: null,
        isShowErrorIcon: false,
      });
    }
  };
  hideQQLogin = (e, imp) => {
    this.setState({
      qq_visible: false,
      qq_open: false,
    });
    if (imp) {
      this.props.loginSuccess && this.props.loginSuccess();
    } else if (this.props.required) {
      _show_login_modal();
    }
  };

  showWeixinLogin = () => {
    _hide_login_modal();
    // 微信用户中心授权登录
    this.setState({
      weixin_visible: true,
      loginErrorTxt: null,
      isShowErrorIcon: false,
    });
  };
  // 微信服务号授权登录
  showWeChatLogin = () => {
    _hide_login_modal();
    this.weChatEle.showModal();
  };
  hideWeixinLogin = (e, imp) => {
    this.setState({
      weixin_visible: false,
    });
    if (imp) {
      this.props.loginSuccess && this.props.loginSuccess();
    } else if (this.props.required) {
      _show_login_modal();
    }
  };

  hidePhoneLogin = (e, imp) => {
    this.setState({
      phone_visible: false,
    });
    if (imp) {
      this.props.loginSuccess && this.props.loginSuccess();
    } else if (this.props.required) {
      _show_login_modal();
    }
  };

  changeFormValue = (e) => {
    let ps = {};
    ps[e.target.name] = e.target.value;
    this.setState(ps);
  };

  getPhoneCode = async () => {
    const {
      base,
      initCaptchaVerified,
      getCaptchaVerified,
      resetCaptchaVerified,
    } = this.props;
    const { rootConfig } = base;
    const { phone, nationCode } = this.state;
    let errorTxt = null;
    if (!phone) {
      errorTxt = '请输入手机号码';
      this.phoneElement.focus();
    }
    if (!Util.validationPhone(phone, nationCode, false)) {
      this.phoneElement.focus();
      errorTxt = '请正确填写手机号码';
    }
    if (errorTxt) {
      this.setState({ loginErrorTxt: errorTxt }, () => {
        this.calcLoginErrorTextLen();
      });
      return;
    }

    this.setState({ loginErrorTxt: null, isShowErrorIcon: false });
    if (getCaptchaVerified()) {
      // 重新获取验证码需要重置验证码
      resetCaptchaVerified();
      await Util.sleep(300);
    }

    initCaptchaVerified({ phone, nationCode, geeType: 1 }, () => {
      const params = {
        lang: rootConfig.lang,
        phone,
        type: 2,
      };
      if (rootConfig.lang !== 'zh_CN') {
        params.areaCode = nationCode;
      }
      const geeValidate = getCaptchaVerified();
      HTTP._send_code({ ...params, ...geeValidate }).then((res) => {
        if (res.code === 200) {
          this.setState({ time: 60 }, () => {
            this.changeTime();
          });
        } else {
          resetCaptchaVerified();
          const loginErrorTxt = res?.message ?? '验证码发送失败，请稍后重试哦~';
          this.setState({ loginErrorTxt }, this.calcLoginErrorTextLen);
        }
      });
    });
  };

  changeTime = () => {
    clearTimeout(this.timer);
    let { time } = this.state;
    if (time <= 0) return;
    this.setState({ time: time - 1 }, () => {
      this.timer = setTimeout(this.changeTime, 1000);
    });
  };

  phoneLogin = () => {
    const {
      base,
      getCaptchaVerified,
      resetCaptchaVerified,
      destroyCaptchaVerified,
    } = this.props;
    const { rootConfig } = base;
    const { phone, isAgree, nationCode, code } = this.state;
    let errorTxt = null;
    if (!phone) {
      errorTxt = '请输入手机号码';
      this.phoneElement.focus();
    }
    if (!isAgree) {
      errorTxt = '未同意用户协议';
    }
    if (phone && !Util.validationPhone(phone, nationCode, false)) {
      this.phoneElement.focus();
    }
    if (phone && !code) {
      errorTxt = '请输入手机验证码';
      this.codeElement.focus();
    }

    if (errorTxt) {
      this.setState({ loginErrorTxt: errorTxt }, () => {
        this.calcLoginErrorTextLen();
      });
      return;
    }

    if (!getCaptchaVerified()) {
      this.setState(
        { loginErrorTxt: '请重新获取验证码' },
        this.calcLoginErrorTextLen
      );
      return;
    }

    this.setState(
      { loading: true, loginErrorTxt: null, isShowErrorIcon: false },
      () => {
        _get_point(() => {
          const params = {
            phone,
            code,
            lang: rootConfig.lang,
          };
          if (rootConfig.lang !== 'zh_CN') {
            params.areaCode = nationCode;
          }
          const bdVid = Util.getParameters('bd_vid');
          if (bdVid) {
            // showUrl 上报
            params['showUrl'] = encodeURIComponent(window.location.href);
          }
          const geeValidate = getCaptchaVerified();
          HTTP._phone_login({ ...params, ...geeValidate })
            .then((res) => {
              if (res?.code === 200) {
                Util.delCookie('enter_room_info'); // 清除进房间跟随
                _set_uid_token({
                  token: res.data.accessToken,
                  uid: res.data.uid,
                  register: 3,
                  qKey: 'newLogin1',
                });
                _get_user_info(
                  {
                    token: res.data.accessToken,
                    uid: res.data.uid,
                    qKey: 'newLogin1',
                  },
                  () => {
                    this.setState({
                      phone: '',
                      code: '',
                      time: 0,
                    });
                    //获取新手优惠券
                    _is_new_process(res.data);
                    Util.delCookie('anonymous_account');
                    _hide_login_modal();
                  },
                  true
                );

                // 登录成功后销毁验证码
                destroyCaptchaVerified();
              } else if (res?.code === 3340) {
                // 账号封禁
                _show_account_abnormal_modal(res);
              } else {
                _anly_seng_custom(1001, { data: res, params });
                // message.error(res.message);
                this.setState(
                  { loginErrorTxt: res.message },
                  this.calcLoginErrorTextLen
                );

                if (res?.code === 5502) {
                  // 验证码失效，需要重新获取
                  resetCaptchaVerified();
                }
              }
            })
            .finally(() => {
              this.setState({ loading: false });
            });
        });
      }
    );
  };

  selNation = (nation) => {
    this.setState({
      nationCode: nation.code,
      nationVisible: false,
    });
  };

  showNationCode = () => {
    this.setState({ nationVisible: !this.state.nationVisible });
  };

  isAgreeProtocol = () => {
    this.setState({
      isAgree: !this.state.isAgree,
    });
  };

  openModel = (title, url) => {
    const { rootConfig } = this.props.base;
    const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
    let modalurl = mobilePath + url + '?v=' + rootConfig.version;
    this.confirmElement.showModal({
      url: modalurl,
      title: title,
      scrolling: 'yes',
      width: '1000px',
      height: '600px',
      zIndex: 1010,
    });
    window.onSuccess = (msg) => {
      if (msg.data === 'newGod') {
        this.hideModal();
        this.confirmElement.hideModal();
        window.removeEventListener('message', window.onSuccess);
      }
    };
    window.addEventListener('message', window.onSuccess);
  };

  closeLogin = () => {
    _hide_login_modal();
    this.props.destroyCaptchaVerified();
  };
  changeLoginType = () => {
    this.setState(
      {
        loginType: this.state.loginType == 0 ? 1 : 0,
        loginErrorTxt: null,
        isShowErrorIcon: false,
      },
      this.props.destroyCaptchaVerified
    );
  };
  // 登录遇到问题
  loginQuestion = () => {
    this.closeLogin();
    this.loginQuestionElement.showModal();
  };
  onLogin = () => {
    const { loginType, loading } = this.state;
    if (loading) {
      message.info('正在登录中...');
      return;
    }
    if (loginType == 0) {
      this.phoneLogin();
    } else if (loginType == 1) {
      this.pwdLogin();
    }
  };
  pwdLogin = () => {
    const {
      base,
      initCaptchaVerified,
      getCaptchaVerified,
      resetCaptchaVerified,
      destroyCaptchaVerified,
    } = this.props;
    const { rootConfig } = base;
    const { phone, password, isAgree, nationCode } = this.state;
    let errorTxt = null;
    if (!phone) {
      errorTxt = '请输入手机号码';
    }
    if (phone && !password) {
      errorTxt = '请输入登录密码';
    }
    if (!isAgree) {
      errorTxt = '未同意用户协议';
    }
    if (errorTxt) {
      this.setState({ loginErrorTxt: errorTxt }, this.calcLoginErrorTextLen);
      return;
    }
    initCaptchaVerified({ phone, nationCode, bizType: 1, geeType: 1 }, () => {
      this.setState(
        { loading: true, loginErrorTxt: null, isShowErrorIcon: false },
        () => {
          _get_point(() => {
            const params = {
              account: phone,
              password,
              lang: rootConfig.lang,
            };
            if (rootConfig.lang !== 'zh_CN') {
              params.areaCode = nationCode;
            }
            const bdVid = Util.getParameters('bd_vid');
            if (bdVid) {
              // showUrl 上报
              params['showUrl'] = encodeURIComponent(window.location.href);
            }
            const geeValidate = getCaptchaVerified();
            HTTP._account_login({ ...params, ...geeValidate })
              .then((res) => {
                if (res.code == 200) {
                  Util.delCookie('enter_room_info'); // 清除进房间跟随
                  _set_uid_token({
                    token: res.data.accessToken,
                    uid: res.data.uid,
                    register: 3,
                    qKey: 'newLogin2',
                  });
                  _get_user_info(
                    {
                      token: res.data.accessToken,
                      uid: res.data.uid,
                      qKey: 'newLogin2',
                    },
                    () => {
                      this.setState({
                        phone: '',
                        code: '',
                        imgCode: '',
                        time: 0,
                      });
                      //获取新手优惠券
                      _is_new_process();
                      Util.delCookie('anonymous_account');
                      _hide_login_modal();
                    },
                    true
                  );
                  destroyCaptchaVerified();
                } else if (res?.code === 3340) {
                  // todo 0801临时处理
                  _show_account_abnormal_modal(res);
                } else {
                  _anly_seng_custom(1001, { data: res, params });
                  // message.error(res.message);
                  this.setState(
                    { loginErrorTxt: res.message },
                    this.calcLoginErrorTextLen
                  );

                  if (res?.code === 5502) {
                    // 验证码失效，请重新获取
                    resetCaptchaVerified();
                  }
                }
              })
              .finally(() => {
                this.setState({ loading: false });
              });
          });
        }
      );
    });
  };

  // 计算是否需要展示错误的 ICON 长度， 设计需求
  calcLoginErrorTextLen = () => {
    const { loginErrorTxt } = this.state;
    if (!!loginErrorTxt) {
      const loginErrorTextDom = document.querySelector('.login-error-text');
      const spanDom = loginErrorTextDom?.querySelector?.('span') || null;
      if (
        spanDom &&
        spanDom.offsetWidth >= loginErrorTextDom.offsetWidth * 0.7
      ) {
        this.setState({ isShowErrorIcon: true });
      }
    }
  };

  render() {
    const { rootConfig, login_visible } = this.props.base;
    const {
      nationCode,
      nationVisible,
      isAgree,
      loginType,
      loading,
      time,
      loginErrorTxt,
      isShowErrorIcon,
    } = this.state;
    return (
      <div className="login-wrapper">
        <Modal
          open={login_visible}
          wrapClassName="transparent-body"
          centered={true}
          closable={false}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="770px"
          zIndex="1010"
          onCancel={_hide_login_modal}
        >
          <div className="m-container">
            {this.props.required ? null : (
              <span className="close" onClick={this.closeLogin} />
            )}
            <div className="left-wrapper">
              <span className="left-welcome" />
            </div>
            <div className="right-wrapper">
              <div className="welcome">
                {loginType == 0 ? '手机号登录' : '手机账号密码登录'}
              </div>
              <span className="notice">未注册的手机号验证后将自动创建账户</span>
              <div className="user-input">
                <div className="form-row">
                  {rootConfig.lang != 'zh_CN' && (
                    <span onClick={this.showNationCode} className="intel-code">
                      +{nationCode}{' '}
                      {nationVisible ? (
                        <CaretUpOutlined />
                      ) : (
                        <CaretDownOutlined />
                      )}
                    </span>
                  )}
                  {rootConfig.lang !== 'zh_CN' &&
                    (nationVisible ? <UpOutlined /> : <DownOutlined />)}
                  <input
                    ref={(el) => (this.phoneElement = el)}
                    type="text"
                    name="phone"
                    autoComplete="off"
                    value={this.state.phone}
                    onChange={this.changeFormValue}
                    placeholder="请输入手机号"
                    maxLength="20"
                  />
                </div>
                {loginType == 0 && (
                  <div className="form-row">
                    <input
                      ref={(el) => (this.codeElement = el)}
                      type="text"
                      name="code"
                      autoComplete="off"
                      value={this.state.code}
                      onChange={this.changeFormValue}
                      placeholder="请输入短信验证码"
                      maxLength="6"
                    />
                    <Button
                      loading={loading}
                      className="send-code"
                      onClick={this.getPhoneCode}
                      disabled={time > 0}
                    >
                      {this.state.time ? (
                        <label>{this.state.time}后重新获取</label>
                      ) : (
                        <span>获取验证码</span>
                      )}
                    </Button>
                  </div>
                )}
                {loginType == 1 && (
                  <div className="form-row">
                    <Password
                      ref={(el) => (this.codeElement = el)}
                      type="password"
                      name="password"
                      autoComplete="off"
                      value={this.state.password}
                      onChange={this.changeFormValue}
                      placeholder="请输入登录密码"
                      maxLength={20}
                    />
                  </div>
                )}
              </div>
              <div className="other-way">
                {!!loginErrorTxt && (
                  <p className="login-error-text">
                    <span>{loginErrorTxt}</span>
                    {isShowErrorIcon && (
                      <Popover
                        rootClassName="login-error-popover"
                        content={loginErrorTxt}
                      >
                        <i className="icon-error-tip" />
                      </Popover>
                    )}
                  </p>
                )}
                {/*<label onClick={this.changeLoginType}>{loginType == 0 ? "使用手机账号密码登录" : "使用手机验证码登录"}</label>*/}
                <label onClick={this.loginQuestion}>登录遇到问题?</label>
              </div>
              <div onClick={this.onLogin} className="login-btn">
                立即登录 {loading ? <LoadingOutlined /> : null}
              </div>
              <div className="agreement">
                <span onClick={this.isAgreeProtocol} className="radio">
                  {isAgree && <i />}
                </span>
                <span className="desc">
                  我已阅读并同意
                  <span
                    onClick={this.openModel.bind(
                      this,
                      '用户协议',
                      '/appagreement/index.html'
                    )}
                  >
                    《平台用户协议》
                  </span>
                  和
                  <span
                    onClick={this.openModel.bind(
                      this,
                      '隐私协议',
                      '/privacy/index.html'
                    )}
                  >
                    《隐私协议》
                  </span>
                </span>
              </div>
              <div className="third-login">
                <Divider className="title">其他登录方式</Divider>
                <div className="icon-list">
                  <span
                    onClick={this.changeLoginType}
                    className={`icon ${loginType == 0 ? 'pwd' : 'phone'}`}
                  />
                  {rootConfig.lang == 'zh_CN' && (
                    <span onClick={this.showWeixinLogin} className="icon wx" />
                  )}
                  {rootConfig.lang == 'zh_CN' && (
                    <span onClick={this.showQQLogin} className="icon qq" />
                  )}
                  {/*{rootConfig.lang != "zh_CN" && <span onClick={this.showFacebookLogin} className="icon facebook"/>}*/}
                  {rootConfig.lang != 'zh_CN' && (
                    <span onClick={this.showLineLogin} className="icon line" />
                  )}
                </div>
              </div>
              {/* 手机号地区选择 */}
              <NationCode
                visible={nationVisible}
                base={this.props.base}
                selNation={this.selNation}
              />
            </div>
          </div>
        </Modal>
        <QQLogin
          base={this.props.base}
          visible={this.state.qq_visible}
          hide={this.hideQQLogin}
          open={this.state.qq_open}
        />
        <WeixinLogin
          base={this.props.base}
          visible={this.state.weixin_visible}
          hide={this.hideWeixinLogin}
        />
        <WeChatLogin
          wrappedComponentRef={(el) => (this.weChatEle = el)}
          base={this.props.base}
          hide={this.hideWeixinLogin}
        />
        {/* 用户迁移 - 绑定手机号 */}
        <BindPhoneSY base={this.props.base} />
        {/* 新人礼包 */}
        <NewbiePack base={this.props.base} />
        {/* 通用弹窗 */}
        <ConfrimIframeModal
          wrappedComponentRef={(el) => (this.confirmElement = el)}
        />
        {/* 登录遇到问题 */}
        <LoginQuestion
          base={this.props.base}
          wrappedComponentRef={(el) => (this.loginQuestionElement = el)}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(jxCaptchaVerifiedHOC(index), { withRef: true })
);
